import {reject, isNil} from 'ramda';

import {CustomerResponseBodyV2} from '@dms/api/customer';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

import {isInvalidEmail} from '../../../utils/isInvalidEmail';

export const getCustomerEmails = (customer: CustomerResponseBodyV2 | Nullish) => {
  const businessEmails = customer?.contacts.flatMap((contact) =>
    contact.emails.flatMap((email) => email.email)
  );
  const foundingPersonEmails = customer?.foundingPerson?.emails.map((email) => email.email);
  const contactEmails = customer?.contacts?.flatMap((contact) =>
    contact.emails.flatMap((email) => email.email)
  );
  const contractInformationEmails = customer?.contractInformation.flatMap((contract) =>
    contract.person?.emails.flatMap((email) => email.email)
  );

  const emails =
    customer?.discriminator === 'BUSINESS'
      ? businessEmails
      : [
          ...(foundingPersonEmails ?? []),
          ...(contractInformationEmails ?? []),
          ...(contactEmails ?? []),
        ];

  const uniqueEmails = new Set(reject(isNil, emails ?? []));

  // The send endpoints refuse an invalid recipient, so it is shown but cannot be chosen
  return Array.from(uniqueEmails).map((email) => ({
    value: email,
    label: isInvalidEmail(email)
      ? `${email} (${i18n.t('general.validations.invalidEmail')})`
      : email,
    isDisabled: isInvalidEmail(email),
  }));
};
